<template>
	<div class="alert" v-prevent-overscroll>
		<div class="alert-area">
			<div class="receive-card-wrapper" :style="baseStyle">
				<div class="receive-card-content"
					:class="[cardAnimation === 'reverse' ? 'receive-card-content-reverse' : '', rotate ? 'reverse' : '']"
					:style="figureStyle">
					<template v-if="!cardAnimation">
						<img class="receive-card-img" :src="info.$$opts && info.$$opts.cardImage" alt="" />
					</template>
					<template v-if="cardAnimation === 'scale'">
						<img class="receive-card-img scale-card-img" :src="info.$$opts && info.$$opts.cardImage"
							alt="" />
					</template>
					<template v-if="cardAnimation === 'reverse'">
						<img class="receive-card-img receive-card-img-front" :src="info.$$opts && info.$$opts.cardImage"
							alt="" />
						<img class="receive-card-img receive-card-img-back" :src="cardBackface" alt="" />
					</template>
				</div>
				<div class="receive-btn" :style="receiveStyle" @click.stop="receiveCard">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
var rem = require('@/utils/rem')
export default {

	name: "receiveCard",

	props: {
		info: { // 查看卡片信息
			type: Object,
			required: true,
			default: () => {
				return {}
			}
		},
	},

	watch: {
		info: {
			handler(val) {
				if (val) {
					this.initStyle(val)
				}
			},
			deep: true,
		}
	},

	data() {

		return {

			baseStyle: { // 基础配置样式

			},

			figureStyle: { // 人物样式

			},

			receiveStyle: { // 收到卡片样式

			},

			cardAnimation: '', // 卡片动画

			cardBackface: '', // 卡片背面

			rotate: '', // 动画

		};

	},

	mounted() {

		this.initStyle(this.info)
	},

	methods: {

		handleCss(options = {}) {
			let str = `.a${JSON.stringify(options).replace(/\"/g, '')}`
			let cssStyle = rem.prototype.generateRem(str).toString()
			cssStyle = cssStyle.substr(0, cssStyle.length - 1)
			cssStyle = cssStyle.slice(7)
			return cssStyle.replace(/\,/g, ';')
		},
		initStyle(val) { // 初始化样式

			let config = val.receiveConfig
			if (config) {
				let { base, figure, receive } = config

				let transform = (config, imgKey) => {

					let options = {}

					if (config.width) {
						options.width = `${config.width}px`
					}

					if (config.height) {
						options.height = `${config.height}px`
					}

					if (config && config.position1 && config.position1.type) {
						options[`${config.position1.type}`] = `${config.position1.value || 0}px`
					}

					if (config && config.position2 && config.position2.type) {
						options[`${config.position2.type}`] = `${config.position2.value || 0}px`
					}

					if (imgKey) {
						if (config[imgKey] && config[imgKey].url) {
							let background = {
								backgroundImage: `url(${config[imgKey].url})`,
								backgroundSize: `100% 100%`,
								backgroundPosition: '0px 0px',
							}
							options = Object.assign(options, background)
						}
					}
					return this.handleCss(options)
				}

				this.baseStyle = transform(base, 'img')
				this.figureStyle = transform(figure, 'background')
				this.receiveStyle = transform(receive, 'img')

				this.cardAnimation = figure.animation
				this.cardBackface = figure.backface.url
				if (this.cardAnimation === 'reverse') {
					setTimeout(() => {
						this.rotate = true
					}, 2000)
				}

			}


		},

		receiveCard() { // 收到卡片
			this.$emit('emitEvent', {
				type: 'closeReceiveCard',
				data: null,
				options: null
			})
			this.$emit('emitEvent', {
				type: 'saveReceiveCard',
				data: {
					id: this.info.winRecordId
				},
				options: {
					cardId: this.info.cardId
				}
			})
		},

	},
};
</script>

<style scoped lang="scss">
.alert {
	position: fixed;
	width: 100%;
	height: 100vh;
	top: 0;
	left: 0;
	z-index: 100;
	background: rgba(0, 0, 0, 0.8);
}

.alert .alert-area {
	height: 100%;
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
}

.receive-card-wrapper {
	position: absolute;
	top: 0;
	width: 100vw;

	.receive-card-content {
		position: absolute;
		z-index: 2;

		&.receive-card-content-reverse {
			transition: all 1s ease;
			transform-style: preserve-3d;
		}

		&.reverse {
			transform: rotateY(-180deg);
		}
	}

	.receive-card-img {
		width: 100%;
		height: 100%;

		&.receive-card-img-front {
			position: absolute;
			top: 0;
			left: 0;
		}

		&.receive-card-img-back {
			position: absolute;
			top: 0;
			left: 0;
			transform: rotateY(-180deg);
		}
	}

	.receive-btn {
		z-index: 3;
		position: absolute;
	}
}

.scale-card-img {
	animation: scaleCardImg 800ms ease-in-out;
}

@keyframes scaleCardImg {
	0% {
		transform: scale(0.2);
	}

	100% {
		transform: scale(1);
	}
}
</style>
